import { render } from "./SummaryLoan.vue?vue&type=template&id=29e73b5c&ts=true"
import script from "./SummaryLoan.vue?vue&type=script&lang=ts"
export * from "./SummaryLoan.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__